export default {
  consumers: [],
};
